import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class SpecialistDataFlowService {
    public addNk$ = new Subject();
    public addPb$ = new Subject();
    public addEducation$ = new Subject();
    public addPermit$ = new Subject();
    public addClothesSizes$ = new Subject();
    public onEdit$ = new Subject();
}
